// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import { mapGetters } from 'vuex'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'
import { sync } from 'vuex-router-sync'
import VueRouter from 'vue-router'
import store from './store/store.js'
import VueScrollTo from 'vue-scrollto'

import MainPage from './components/MainPage'
import ExperimentPage from './components/ExperimentPage'
import PreExperiment from './components/PreExperiment'
import ExperimentResult from './components/ExperimentResult'
import Profile from './components/Profile'
import TestPage from './components/TestPage'
import CortexAPITestPage from './components/ExperimentCortex'

import App from './App'

Vue.use(Vuex)
Vue.use(VueMaterial)
Vue.use(VueRouter)
Vue.use(VueScrollTo)
Vue.use(require('vue-moment'));

Vue.material.registerTheme('default', {
  primary: 'light-green',
  accent: 'green',
  warn: 'red',
})


export const router = new VueRouter({
	  routes: [
	    { path: '/', name:'home', component: MainPage },
	    { path: '/preexperiment', name:'preexperiment', component: PreExperiment, props:true},
	    { path: '/experiment', name: 'experiment', component: ExperimentPage, props:true },
	    { path: '/result/:id', name: 'experiment_result', component: ExperimentResult, props:false },
	    { path: '/profile', component: Profile },
		{ path: '/test', component: TestPage, props: { message: 'Props message' } },
		{ path: '/cortex_api_test', component: CortexAPITestPage }
	  ],
	  scrollBehavior (to, from, savedPosition) {
		  return { x: 0, y: 0 }
		}
	})

const unsync = sync(store, router)

Object.defineProperty(Vue.prototype, '$bus', { // global event bus. use it as $bus in any component
	get() {
		return this.$root.bus;
	}
});

Vue.config.errorHandler = function (err, vm, info) {
	  console.log(err)
	}

Vue.mixin({
	computed: {
    	...mapGetters({
    		isAuth: 'isLoggedIn',
    		currentUser: 'getUser'
    	    }),
	},
	})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  router: router,
  store: store,
  components: { App },
  data: {
		bus: new Vue({}),// Here we bind our event bus to our $root Vue model.
  }
})



// WEBPACK FOOTER //
// ./src/main.js